import React, { useEffect, useState, useMemo , useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetTheLeavePermissionListActions,
  setClientBranchSearchAction,
  SetTheLeavePermissionListSearchActions,
  SetTheLeavePermissionDelete,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheLeaveRequestState,
  setTheLeaveRequestRegion,
  setTheLeaveRequestZone,
  setheLeaveRequestesignationStatus,
  setTheLeaveRequestStateStatus,
  setTheLeaveRequestRange1,
  setTheLeaveRequestRange2,
  setTheLeaveRequestBranchList,
  setTablePositionPersist
} from "../../../Redux/Slice";
import Select from "react-select";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import LeavePermissionEdit from "./LeavePermissionEdit";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import _, { values } from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import useDebouncedEffect from 'use-debounced-effect';
import dayjs from "dayjs";



const LeavePermission = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.LeaveRequestPageViews?.page == undefined
      ? 1
      : TablePositionPersist.LeaveRequestPageViews.page
  );
  const [search, setsearch] = useState(
    TablePositionPersist?.LeaveRequestPageViews?.search == "" ||TablePositionPersist?.LeaveRequestPageViews?.search == undefined
      ? ""
      : TablePositionPersist.LeaveRequestPageViews.search
  );

  const dateRangeRef = useRef(null);
  

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const state = useSelector((state) => state);
  const [counts, setCounts] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  const [selectedValues, SetSelectValue] = useState([]);
  const [Branchname, setBranchName] = useState("");

  let Ids = [];
  const [Client, setClients] = useState(state.StateManagementOverallCall.Leave_RequestBranchList?.value);
  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  console.log(yearAndMonth, "yearAndMonth");
  const displaydate =
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

  const YearList = date.getFullYear();
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Datestate, setdata] = useState({
    date: displaydate,
    month: months,
    year: YearList,
  });

  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);

  const [multiselect1, setMuliselect1] = useState([
    state.StateManagementOverallCall.Leave_RequestRegion,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    state.StateManagementOverallCall.Leave_RequestZone,
  ]);
  const [nameList5, setOptions5] = useState([]);
  const [Zone, setZone] = useState([]);

  const [data, setData] = useState({
    zone: state.StateManagementOverallCall.Leave_RequestZone?.value,
    state: state.StateManagementOverallCall.Leave_RequestState?.value,
    region: state.StateManagementOverallCall.Leave_RequestRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    state.StateManagementOverallCall.Leave_RequestState,
  ]);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.Leave_RequestRange1);
  var gt = convert(state.StateManagementOverallCall.Leave_RequestRange2);
         const today_day = dayjs().format("YYYY-MM-DD");
  
  const [range, setrange] = useState(
    state.StateManagementOverallCall.Leave_RequestRange1 == ""
      ? [today_day ,today_day] 

      : [it, gt]
  );


  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };


  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheLeaveRequestRange1(range[0]));
      dispatch(setTheLeaveRequestRange2(range[1]));
    }
        if(state.StateManagementOverallCall.Leave_RequestRange1 == ""){
          dispatch(setTheLeaveRequestRange1(today_day));
          dispatch(setTheLeaveRequestRange2(today_day));
    
        }
  }, [range]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({ white_collar: 

    state.StateManagementOverallCall.Leave_Requestdesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Leave_Requestdesignation?.value == 1 ?
    true:
    false



   });
  const HandleEMprole = (e) => {
    if (e != null) {
      setdtPageindex(1);
       dispatch(setheLeaveRequestesignationStatus(e))
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        setClients("");
        dispatch(setTheLeaveRequestBranchList({value:"",label:"ALL"}))

      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
         dispatch(setTheLeaveRequestBranchList({value:"",label:"ALL"}))
        setClients("");
         dispatch(setheLeaveRequestesignationStatus({value:"",label:"ALL"}))
      }
    }
  };

  const FileterState = {
    status: state.StateManagementOverallCall.Leave_RequestStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  const [SearchBranch, setSearchBranch] = useState();
  ////--_FIlter--------------------------
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch:""
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch:e
    
    })  };
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: selectedVal.value,
      });

      dispatch( setTheLeaveRequestRegion(selectedVal));
       dispatch(setTheLeaveRequestZone({ value: "", label: "ALL" }));
 


    }
    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });

      dispatch( setTheLeaveRequestRegion({ value: "", label: "ALL" }));
       dispatch(setTheLeaveRequestZone({ value: "", label: "ALL" }));
 

    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });

       dispatch(setTheLeaveRequestZone(selectedVal));
 

    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });

       dispatch(setTheLeaveRequestZone({ value: "", label: "ALL" }));
 

    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheLeaveRequestState(selectedVal));
     dispatch( setTheLeaveRequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheLeaveRequestZone({ value: "", label: "ALL" }));

dispatch(setTheLeaveRequestBranchList({ value: "", label: "ALL" }))
      setData({
        ...data,
        state: selectedVal.value,
        zone: "",
        region: "",
      });

      setClients("");
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheLeaveRequestState({value:"",label:"ALL"}));
      dispatch( setTheLeaveRequestRegion({ value: "", label: "ALL" }));
       dispatch(setTheLeaveRequestZone({ value: "", label: "ALL" }));
 
 dispatch(setTheLeaveRequestBranchList({ value: "", label: "ALL" }))
      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
      setClients("");
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

 
  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });
            setSearchBranch(SearchDebounance.Clientsearch)
        }
    },
    500,
    [SearchDebounance]
);

///-----State----Input Changes
const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

  //--------Place---Holder----dispatch======

  useEffect(() => {
    const payload = {
      search: SearchBranch,
      page_size: dtpagesize,
      page: dtpageindex,
      data: data,
    };
    dispatch(setClientBranchSearchAction(payload));
  }, [SearchBranch, data]);
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      // if (
      //   state.LeavePremissionLists.LeavePermissionList.length == 0 ||
      //   TablePositionPersist?.LeaveRequestPageViews?.page != dtpageindex ||
      //   TablePositionPersist?.LeaveRequestPageViews?.search != search ||
      //   TablePositionPersist?.LeaveRequestPageViews?.status != selectVal.status ||
      //   TablePositionPersist?.LeaveRequestPageViews?.from_date != range[0] ||
      //   TablePositionPersist?.LeaveRequestPageViews?.to_date != range[1] ||
      //   TablePositionPersist?.LeaveRequestPageViews?.white_collar !== filterForWhite.white_collar ||
      //   TablePositionPersist?.LeaveRequestPageViews?.state != data.state ||
      //   TablePositionPersist?.LeaveRequestPageViews?.region != data.region ||
      //   TablePositionPersist?.LeaveRequestPageViews?.zone != data.zone ||
      //   TablePositionPersist?.LeaveRequestPageViews?.client != Client ||
      //     TablePositionPersist?.LeaveRequestPageViews?.isApproved 
      // ) {
      const payloads = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        status: selectVal.status,
        white_collar: filterForWhite.white_collar,
        from_date: range[0],
        to_date: range[1],
        state: data.state,
        region: data.region,
        zone: data.zone,
        client: Client,
      };
      dispatch(SetTheLeavePermissionListActions(payloads));
      dispatch(
        setTablePositionPersist({
          data: payloads,
          pageName: "LeaveRequestPageViews",
        })
      );
    // }



    }
     currentRef.current.scrollTop = sessionStorage.getItem(
      "LevaeRequestPagescroll"
    );
    

  }, [Client, selectVal, filterForWhite, range, data, dtpageindex , search]);
  console.log(Client, "3097ujClient");
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, SearchBranch]);


  const HandleClientBranches = (selectedVal) => {
    if (selectedVal != null) {
      setClients(selectedVal.value);
       dispatch(setTheLeaveRequestBranchList(selectedVal))
    } else {
      setClients("");
      dispatch(setTheLeaveRequestBranchList({value:"",label:"ALL"}))

    }
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);

      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    // setsearch(e);
    debouncedSearch(e);
    setdtPageindex(1);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const columns = [
//          {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name != undefined ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>----</span>
            )}
          </>
        );
      },
    },

    {
      Header: "From Date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.from_date ? (
              <span>{row.row.original.from_date}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "To Date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.to_date ? (
              <span>{row.row.original.to_date}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Reason",
      accessor: "leave_type",
      Cell: (row) => {
        return (
          <>
            {row.row.original.leave_type != undefined &&
            row.row.original.leave_type.leave_type != undefined ? (
              <span>{row.row.original.leave_type.leave_type}</span>
            ) : (
              <span>not mention</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            {formattedTime != undefined ? (
              <span>
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </span>
            ) : null}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              {/* {row.row.original.status.toLowerCase() == "pending" ? ( */}

              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  // style={{ cursor: "not-allowed" }}
                  disabled
                >
                  <span className="OuterActionSpan">

                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                    <span className="ActionsList"> Approved </span>
                  </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      disabled
                      // style={{ cursor: "not-allowed" }}
                  
                    >
                      <span className="OuterActionSpan">

                         <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                        <span className="ActionsList"> Decline </span>
                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          <span className="OuterActionSpan">
                              <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                            <span className="ActionsList"> Approve </span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  const HandleSubmits = () => {
    const payload = {
      DeleteID: DeleteID,
      currentPage: currentPage,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheLeavePermissionDelete(payload, setDeletePopup(false)));
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      dispatch(setTheLeaveRequestStateStatus({value:"",label:"All"}));

    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);

    setSelected(sel);
    SetStates(true);
    dispatch(setTheLeaveRequestStateStatus(SelectedValues));

    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,

        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '874.344px', 'important');
      rsAnimFade.style.setProperty('top', '193.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
    const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop; 
    sessionStorage.setItem("LevaeRequestPagescroll", val);
  };

  const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};

  return (
    <>
      <div 
                    onScroll={scrollPosition}
              ref={currentRef}

      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Leave Request</h3>

          </div>
        </div>

        <div
          className=" row Filters "
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop:"-7px "
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
            >
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
            />
          </div>

          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
            >
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
      isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
            >
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
         isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   if (e != null) {
              //     SetSelectValue(e);
              //     dispatch(SetTheDashboardClientList(e));
              //   }
              // }}
              filterOption={() => true}
              onChange={(e) => {
                HandleClientBranches(e);
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
      isClearable={
  state.StateManagementOverallCall.Leave_RequestBranchList
    ? Array.isArray(state.StateManagementOverallCall.Leave_RequestBranchList)
      ? state.StateManagementOverallCall.Leave_RequestBranchList.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.StateManagementOverallCall.Leave_RequestBranchList.label === "ALL" || state.StateManagementOverallCall.Leave_RequestBranchList.label === "All"
      ? false
      : true
    : true
}              isDisabled={filterForWhite.white_collar ? true : false}
              // isMulti
              value={state.StateManagementOverallCall.Leave_RequestBranchList}
            />
          </div>

          <div
            className="col-2"
            style={{
              zIndex: "20",
              marginLeft: "-10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "-21px",
            }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall.Leave_RequestRange1 == ""
                    ?
                    [new Date(range[0]), new Date(range[1])]
                    : [
                        new Date(state.StateManagementOverallCall.Leave_RequestRange1),
                        new Date(state.StateManagementOverallCall.Leave_RequestRange2),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
            //     onOpen={() => {
            //       openMe()
            //     }}
            //  onClose={() => {
            //     CloseDateRange()
            //        }}
                                                             ref={dateRangeRef}

          onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                onClean={false}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 20px 40px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                top: "95px",
                width: "92%",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ width: "314px" }}></div>
            </div>

            <ReactTable
              data={state.LeavePremissionLists.LeavePermissionList}
              columns={columns}
              totalItems={state.LeavePremissionLists.Total_Count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              pageindex={pageindex}
              datacount={state.LeavePremissionLists.Total_Count}
              values={state.StateManagementOverallCall.Leave_RequestStatusState}
              options={options}
              ApproveRequestFilter={true}
              Filter={true}
              count={count}
              ClearState={ClearState}
              placeHold={"All"}
              EmployeeRoleTrue={true}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={state.StateManagementOverallCall.Leave_Requestdesignation}
              HandleEMprole={HandleEMprole}
                                                searchVal={TablePositionPersist?.LeaveRequestPageViews?.search == "" || TablePositionPersist?.LeaveRequestPageViews?.search ==undefined? "":TablePositionPersist.LeaveRequestPageViews.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
        />
      ) : null}

      {EmployeePop && EmployeeIDs != undefined && selectVal ? (
        <LeavePermissionEdit
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectValgetfilter={selectVal.status}
          white_collar={filterForWhite.white_collar}
          clientFilter={Client}
          DatasFilters={data}
          from_date={range[0]}
          search={search}
          to_date={range[1]}
        />
      ) : null}
    </>
  );
};

export default LeavePermission;
